import { render, staticRenderFns } from "./ViewSalaryCertificate.vue?vue&type=template&id=2ce25e3a&scoped=true"
import script from "./ViewSalaryCertificate.vue?vue&type=script&lang=js"
export * from "./ViewSalaryCertificate.vue?vue&type=script&lang=js"
import style0 from "./ViewSalaryCertificate.vue?vue&type=style&index=0&id=2ce25e3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce25e3a",
  null
  
)

export default component.exports